<main class="ibox-content  mb-4">
  <form [formGroup]="form" (ngSubmit)="salvar()" (keydown.enter)="onKeydownEnter($event)" >
    <fieldset class="form-body row col-md-8">
      <div class="col-md-12 m-b">
        <label class="col-sm-12 pb-1">Título / Pauta:<sup class="text-danger">*</sup></label>
        <textarea id="description" class="form-control" formControlName="description"  (input)="limitLines($event)" maxlength="400"></textarea>
        <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
      </div>
      <div class="col-md-12 m-b">
        <label class="col-sm-12 pb-1"><b class="agency-title">Órgão Responsável:<sup *ngIf="type !== 'editar'" class="text-danger">*</sup></b>
          <b *ngIf="type === 'editar' && !isLoading" class="agency-name"> {{ getAgencyLabel()}} </b>     
        </label>
        <ng-select id="agency_id" class="ng-select-alternative col-sm-6 pb-1" [items]="filters?.agency_select" 
          bindLabel="label" bindValue="id" formControlName="agency_id" *ngIf="type !== 'editar'"
          >
        </ng-select>   
        <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
      </div>
      <div class="col-md-4 m-b section-field">
        <label class="col-sm-12 pb-1">Nível de Acompanhamento:</label>
        <ng-select id="level_mon_id" class="ng-select-alternative" [items]="filters?.levelMonitoringSelect" 
          bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="level_mon_id">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('level_mon_id')" [erros]="fieldErros('level_mon_id')"></app-field-message>
      </div>
      <div class="col-md-4 m-b section-field">
        <label class="col-sm-12 pb-1">Exercício:<sup class="text-danger">*</sup></label>
        <ng-select id="accord_main_id" class="ng-select-alternative" [items]="filters?.yearSelect"  (change)="searchAgency()"
          bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="accord_main_id">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('accord_main_id')" [erros]="fieldErros('accord_main_id')"></app-field-message>
      </div>
      <div class="col-md-4 m-b section-field">
        <label class="col-sm-12 pb-1">Nível de Governança:<sup class="text-danger">*</sup></label>
        <ng-select id="governance_level_id" class="ng-select-alternative" [items]="filters?.governanceLevelSelect"
          bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="governance_level_id">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('governance_level_id')" [erros]="fieldErros('governance_level_id')"></app-field-message>
      </div>
      <div class="col-md-4 m-b section-field">
        <label class="col-12 pb-1">Data:<sup class="text-danger">*</sup></label>
        <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_meet" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }">
        <app-field-message [field]="fieldMessageRequired('dt_meet')" [erros]="fieldErros('dt_meet')"></app-field-message>
      </div>
      <div class="col-sm-6 col-md-4  m-b section-field">
        <label class="col-12 pb-1">Hora Início:</label>
        <input class="form-control" type="time" formControlName="hr_meeting_start">
        <app-field-message [field]="fieldMessageRequired('hr_meeting_start')" [erros]="fieldErros('hr_meeting_start')"></app-field-message>
      </div>
      
      <div class="col-sm-6 col-md-4  m-b section-field">
        <label class="col-12 pb-1">Hora Fim:</label>
        <input class="form-control" type="time" formControlName="hr_meeting_end">
        <app-field-message [field]="fieldMessageRequired('hr_meeting_end')" [erros]="fieldErros('hr_meeting_end')"></app-field-message>
      </div>

      <!--<div class="col-md-6 col-lg-4 m-b">
        <label class="col-sm-12 pb-1">Tipo reunião</label>
        <ng-select id="meeting_type_id" class="ng-select-alternative" [items]="filters?.meetingTypeSelect" 
          bindLabel="label" bindValue="id" placeholder="Todos" formControlName="meeting_type_id">
        </ng-select>
      </div

      <div class="col-md-6 col-lg-4 m-b" *ngIf="form.controls.meeting_type_id.value == 2">
        <label class="col-sm-12 pb-1">Eixo</label>
        <ng-select id="axis_id" class="ng-select-alternative" [items]="filters?.governanceLevelSelect" 
          bindLabel="label" bindValue="id" placeholder="Todos" formControlName="axis_id">
        </ng-select>
      </div>>--><!--Sheyla pediu para retirar-->

      <div class="line"></div>
      <div class="col-md-6 d-lg-none" *ngIf="[2,3].includes(form.controls.meeting_type_id.value)"></div>

      <div class="col-md-12 m-b">
        <div class="d-flex justify-content-between">
          <label class="pb-1">Órgãos Participantes:<sup class="text-danger">*</sup></label>
        </div>
        <small *ngIf="dirtyListItem('accord_main_id')" class="text-danger">
          Selecione o Exercício
        </small> 
        <div formArrayName="agency" class=" w-100">
          <div *ngFor="let item of getFormArray('agency').controls; let i = index" class="m-b row g-0 select-agency">
            <div class="col-10 col-sm-11">  
              <ng-select [id]="'agency_'+i" class="ng-select-alternative" [items]="filters?.agency_list"
                bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Selecione" [formControlName]="i"
                notFoundText="Selecione o Exercício">
              </ng-select>
            </div>
            <div class="div-button col-2 col-sm-1">
              <div class="d-flex justify-content-end">
                <button class="btn btn-font-icon" type="button" (click)="removeItem('agency', i)" alt="Remover órgão fixo">
                  delete
                </button>
              </div>
            </div>
          </div>
        </div>        
        <button class="btn btn-primary" type="button" (click)="addItem('agency')" alt="Adicionar órgão participante">
          Novo órgão participante
        </button>
      </div>
      <div class="line"></div>
      <div class="col-md-12 m-b" *ngIf="form.controls.meeting_type_id.value == 3">
        <div class="d-flex justify-content-between">
          <label class="pb-1">Órgãos Fixos</label>
        </div>
        <div formArrayName="agency_fixed" class=" w-100">
          <b *ngIf="getFormArray('agency_fixed').controls.length == 0" class="mb-2" >Nenhum</b>
          <div *ngFor="let item of getFormArray('agency_fixed').controls; let i = index" class="m-b row g-0 select-agency">
            <div class="col-10 col-sm-11"> 
              <ng-select [id]="'agency_fixed'+i" class="ng-select-alternative" [items]="filters?.agency_list" 
                bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Selecione" [formControlName]="i"
                notFoundText="Selecione um órgão responsável">
              </ng-select>
            </div>
            <div class="div-button  col-2 col-sm-1">
              <button class="btn btn-font-icon" type="button" (click)="removeItem('agency_fixed', i)" alt="Remover órgão fixo">
                delete
              </button>
            </div>
          </div>
          <button class="btn btn-primary" type="button" (click)="addItem('agency_fixed')" alt="Adicionar órgão fixo">
            Novo órgão fixo
          </button>
        </div>
      </div>
    </fieldset>

    <hr class="final-line">
    <footer class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()" alt="Voltar">Voltar</button>
        <button class="btn btn-primary" type="submit" alt="Salvar reunião">Salvar</button>
      </div>
    </footer>
  </form>
</main>
<app-loading [loader]="isLoading"></app-loading>